import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Input, Spin } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';//props传参检查库
import Message from '../../component/message/message'; // 提示信息弹窗
import './wilProgrammeSetup.css';

const CloneModal = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);

    useEffect(() => {
        form.setFieldsValue({});
    }, []);

    // 生成提示信息
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const save = () => {
        props.onClose(false);
    }

    const onCancel = (flag = false) => {
        props.onClose(flag);
    }

    return (
        <Spin size="large" spinning={isLoad} tip="Data is processing...">
            <Modal
                className="wilProgrammeSetupCloneModal"
                visible={true}//控制弹框是否显示
                title="Clone WIL Programme Setup"//标题
                centered//垂直居中
                destroyOnClose={true}//关闭即销毁？
                closable//是否显示右上角的关闭按钮
                maskClosable={false}//点击蒙层是否允许关闭	
                // width={Config.equipmentInfo.type === 'iPad' ? '65%' : (Config.equipmentInfo.type === 'phone' ? '100%' : '50%')}//弹框宽度
                width={'600px'}
                onCancel={() => onCancel(false)}//点击取消触发事件
                footer={[
                    <Button key='save' className="sysBtn btnBlue" type="primary" onClick={save} icon={<CheckCircleOutlined />}>Clone</Button>,
                    <Button key='cancel' className="sysBtn" onClick={() => onCancel(false)} icon={<CloseCircleOutlined />}>Cancel</Button>
                ]}
            >
                <Message ref={messageRef} />
                <div className='sysRow'>
                    <div className='sysCol'>
                        <div className="sysTitles">Cohort</div>
                        <div className="sysSerchInput">
                            <Form.Item
                                name="cohortYear"
                            >
                                <Input type="text" placeholder="Cohort" maxLength={4} />
                            </Form.Item>
                        </div>
                    </div>
                </div>
            </Modal>
        </Spin>
    )

}

CloneModal.propTypes = {
    onClose: PropTypes.func.isRequired,
}

export default CloneModal;